<div class="modal-header">
  <button
    type="button"
    (click)="dismiss()"
    class="btn-close"
    title="Close"></button>
  <h3>Invite Another Person</h3>
</div>

<div class="modal-body clearfix">
  <br />
  <div class="row">
    <div class="col-lg-6">
      <label class="form-label" for="email-field">Email</label>
      <input
        id="email-field"
        class="form-control"
        type="text"
        [(ngModel)]="invite.email" />
    </div>
    <div class="col-lg-6">
      <label class="form-label" for="organization-field">Organization</label>
      <input
        id="organization-field"
        class="form-control"
        type="text"
        [(ngModel)]="invite.organization" />
    </div>
    <div class="col-lg-6">
      <label class="form-label" for="first_name-field">First Name</label>
      <input
        id="first_name-field"
        class="form-control"
        type="text"
        [(ngModel)]="invite.first_name" />
    </div>
    <div class="col-lg-6">
      <label class="form-label" for="name-field">Last Name</label>
      <input
        id="name-field"
        class="form-control"
        type="text"
        [(ngModel)]="invite.name" />
    </div>
    <div class="col-lg-12">
      <label class="form-label" for="message-field">Invitation Message</label>
      <textarea
        id="message-field"
        class="form-control"
        [(ngModel)]="invite.message"></textarea>
    </div>
  </div>
  <h3>Topics</h3>
  <p>
    The person will be invited to the following topics with specified roles:
  </p>
  <div class="row session-row" *ngFor="let s of sessions">
    <div class="col-lg-6">
      <input type="checkbox" [(ngModel)]="s.selected" [id]="'role-' + s.role" />
      &nbsp;
      <label class="form-label" [for]="'role-' + s.role">
        {{ s.session.config.title }}
      </label>
    </div>
    <div class="col-lg-6">
      <select
        class="form-control"
        [disabled]="!s.selected"
        [(ngModel)]="s.role">
        <option
          *ngFor="let role of selectableRoles(s.session)"
          [ngValue]="role.value">
          {{ role.name }}
        </option>
      </select>
    </div>
  </div>
  <br />
  <div style="text-align: right">
    <button
      class="btn-lg btn-primary btn"
      [disabled]="invalid()"
      (click)="sendInvite()">
      Invite to Topics
    </button>
  </div>
</div>
